import * as api from "api/Core";
import { GenericLogDialog, GenericLogDialogProps, ILogTranslated } from "components/GenericLogDialog";
import SystemRoleName from 'components/Translations/SystemRoleName';
import { SystemRoles } from 'models/ApiEnums';
import { LogRecord } from "models/ApiModels";
import * as React from 'react';
import { Fragment } from 'react';
import { withTranslation } from 'react-i18next';

///////////////////////////////////////////////////////////////////////////////

interface IProps extends GenericLogDialogProps {
    groupId: string;
}

///////////////////////////////////////////////////////////////////////////////

class GroupLogDialog extends GenericLogDialog<IProps> {

    getLog(offset: number, take: number) {
        return api.getGroupLog(this.props.groupId, offset, take);
    }

    translate(data: LogRecord[]): ILogTranslated[] {
        const result: ILogTranslated[] = [];

        data.forEach((v) => {
            var j = v.jsonData;

            Object.keys(j).forEach((key) => {

                const r: ILogTranslated = {
                    name: this.defaultFieldName(key, "Group"),
                    content: "?",
                    creationDate: v.creationDate,
                    creator: v.creator,
                };

                switch (key) {
                    case "Name":
                        r.content = this.valueFromToTranslate(j[key]["From"], j[key]["To"]);
                        break;

                    case "Thumbnail":
                        r.content = this.modifiedLiteral;
                        break;

                    case "Permissions":
                        {
                            const data = j[key] as PascalCaseKeyValueItem<SystemRoles, string>[];
                            r.content = (
                                <Fragment>
                                    {
                                        data.map((v) => (<div><b><SystemRoleName role={v.Key} />:</b> <span>{v.Value == "add" ? this.props.t("Common.ValueAdded") : this.props.t("Common.ValueDeleted")}</span></div>))
                                    }
                                </Fragment>
                            );
                        }
                        break;

                    case "Members":
                    case "SuggestedTopics":
                        r.content = this.addOrDeleteDictionaryTranslate(j[key] as PascalCaseKeyValueItem<string, string>[]);
                        break;
                }
                result.push(r);
            });
        });

        return result;
    }
}

export default withTranslation("log")(GroupLogDialog);